import axios from 'axios';

export const FREE_LIMIT_EVENT = 'free-limit-reached';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const api = axios.create({
  baseURL: API_BASE_URL
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;

    if (status === 402 && data?.requirePremium) {
      if (typeof window !== 'undefined' && window.dispatchEvent) {
        const message =
          data.error ||
          'Bu ay ücretsiz kullanım hakkın doldu. Premium Pass satın alarak devam edebilirsin.';
        window.dispatchEvent(
          new CustomEvent(FREE_LIMIT_EVENT, { detail: message })
        );
      }
    }

    return Promise.reject(error);
  }
);
